import { useMutation } from '../';
import { deleteInvestmentMutation } from '../mutations';

export function useDeleteInvestmentMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(deleteInvestmentMutation, variables, () => {
      if (onFinish) {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
